export const AUTH_ERRORS: Record<number, string> = {
  302: 'No autorizado (302)',
  401: 'No autorizado (401)',
  403: 'Acceso prohibido (403)'
}

export const ERROR_MESSAGES: Record<number, string> = {
  400: 'Solicitud incorrecta (400)',
  ...AUTH_ERRORS,
  404: 'Recurso no encontrado (404)',
  500: 'Error en el servidor (500)'
}

export const DEFAULT_ERROR_MESSAGE = 'Ocurrió un error inesperado'
export const CORS_ERROR_MESSAGE = 'No se puede acceder al servidor desde este origen.'

export function isCORSError(error: any): boolean {
  if (!error.message) return false

  const corsErrorPatterns = [
    'Network Error',
    'CORS',
    'Failed to fetch',
    'Access-Control-Allow-Origin',
    'cross-origin',
    'has been blocked by CORS policy'
  ]

  return corsErrorPatterns.some((pattern) => error.message.includes(pattern))
}

export function getError(error: any) {
  return error instanceof Error ? error : new Error(String(error))
}

export class ConectionError extends Error {
  constructor() {
    super(CORS_ERROR_MESSAGE)
    this.name = 'Error de conexión'
  }
}

export class UnauthorizedError extends Error {
  constructor(message: string = AUTH_ERRORS[401]) {
    super(message)
    this.name = 'Unauthorized Error'
  }
}
